import React, { FunctionComponent } from 'react';

interface Props {
    colors: string[];
    values: number[];
    extras?: string[];
}

const BarChart: FunctionComponent<Props> = ({ colors, values, extras }) => {

    return (
        <div className={'bar-chart'}>
            <div className={'bar-chart__line'} />

            { values.map((value, index) => (
                <div className={'bar-chart__bar-container'} style={{ width: `${values[index]}%` }} key={colors[index]}>
                    <div className={'bar-chart__bar'} style={{ backgroundColor: `#${colors[index]}` }}>
                        <span className={'bar-chart__text'}>{ extras ? extras[index] : `${Math.round(values[index])}%` }</span>
                    </div>
                </div>
            )) }
        </div>
    );
};

export default BarChart;
